"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsGetAvailableBalanceEnabled = exports.useGetAvailableBalance = void 0;
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _presentationUtils = require("@ori/presentation-utils");
var _react = require("react");
var _constants = require("./constants");
const useIsGetAvailableBalanceEnabled = () => {
  const {
    customerId,
    isAnonymousUser,
    isUserVerified
  } = (0, _auth.useToken)();
  const [isAllowedUrlPathname, setIsAllowedUrlPathname] = (0, _react.useState)(true);
  const [isHidden, setIsHidden] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setIsAllowedUrlPathname(!/^\/([a-z]{2}\/)?(mypages|shopping\/basket)\/?/.test(window.location.pathname));
    if (isUserVerified) {
      if (window.localStorage.getItem(_constants.WALLET_AMOUNT_MESSAGE_BANNER_LOCAL_STORAGE_KEY) === String(customerId)) {
        setIsHidden(true);
      } else {
        window.localStorage.removeItem(_constants.WALLET_AMOUNT_MESSAGE_BANNER_LOCAL_STORAGE_KEY);
      }
    }
  }, [customerId, isAnonymousUser, isUserVerified]);
  return isAllowedUrlPathname && isUserVerified && !isAnonymousUser && !isHidden;
};

// istanbul ignore next @preserve -- api
exports.useIsGetAvailableBalanceEnabled = useIsGetAvailableBalanceEnabled;
const useGetAvailableBalance = () => {
  const {
    customerId
  } = (0, _auth.useToken)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const enabled = useIsGetAvailableBalanceEnabled();
  const {
    data: {
      availableBalance
    } = {
      availableBalance: 0
    }
  } = (0, _globalApiClientReact.useGetCustomerWalletReport)(customerId, {
    [_fetching.TENANT_CONTEXT]: tenant
  }, {
    swr: {
      ...(0, _presentationUtils.getRetryErrorSwrOptions)(),
      enabled
    }
  });
  return availableBalance;
};
exports.useGetAvailableBalance = useGetAvailableBalance;